/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Clear_TitleInputs */

const en_us2_plan_build_clear_title = /** @type {(inputs: Plan_Build_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete every workout?`)
};

const pt_br2_plan_build_clear_title = /** @type {(inputs: Plan_Build_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar todos os treinos?`)
};

const es_419_plan_build_clear_title = /** @type {(inputs: Plan_Build_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Borrar todos los entrenamientos?`)
};

const pt_pt2_plan_build_clear_title = /** @type {(inputs: Plan_Build_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar todos os treinos?`)
};

const fr_fr2_plan_build_clear_title = /** @type {(inputs: Plan_Build_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer toutes les séances ?`)
};

const de_de2_plan_build_clear_title = /** @type {(inputs: Plan_Build_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Trainings löschen?`)
};

const it_it2_plan_build_clear_title = /** @type {(inputs: Plan_Build_Clear_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare tutti gli allenamenti?`)
};

/**
* | output |
* | --- |
* | "Delete every workout?" |
*
* @param {Plan_Build_Clear_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_clear_title = /** @type {((inputs?: Plan_Build_Clear_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Clear_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_clear_title(inputs)
	if (locale === "es-419") return es_419_plan_build_clear_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_clear_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_clear_title(inputs)
	if (locale === "de-DE") return de_de2_plan_build_clear_title(inputs)
	if (locale === "it-IT") return it_it2_plan_build_clear_title(inputs)
	return en_us2_plan_build_clear_title(inputs)
});
export { plan_build_clear_title as "plan-build.clear_title" }